import { render, staticRenderFns } from "./MErrorWrapper.vue?vue&type=template&id=063a887f&scoped=true"
import script from "./MErrorWrapper.vue?vue&type=script&lang=js"
export * from "./MErrorWrapper.vue?vue&type=script&lang=js"
import style0 from "./MErrorWrapper.vue?vue&type=style&index=0&id=063a887f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063a887f",
  null
  
)

export default component.exports